<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout=""
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
    >
      <a-row :gutter="[16, 24]">
        <a-col 
          v-for="(item, index) in Details" 
          :key="index" 
          :xs="24" 
          :sm="12" 
          :md="12" 
          :lg="8"
        >
          <a-form-model-item
            :label="item.iconName"
          >
            <a-switch
              :checked="item.isUse === 1 ? true : false"
              @change="onChange(item)"
              checked-children="开启"
              un-checked-children="关闭"
            />
            <div v-if="item.iconName === '注册电子会员'">
              <!-- <a-date-picker v-model="item.date" />
               <a-button type="primary"  @click="handleSubmit(item)">提交</a-button> -->
            </div>
            <span></span>
            <!-- <span class="tipspan">tips:开启后各个门店游戏币/彩票统一通用</span> -->
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { storeFunction, functionEdit,functionEditDate } from "@/api/homeApi.js";
import { message } from "ant-design-vue";

// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      show: false,
      currencyRecord: "",
      Details: [],
    };
  },
  mounted() {
    this.getStoreFunction();
  },
  methods: {
    onChange(item) {
      if (item.isUse === 1) {
        functionEdit({
          iconId: item.iconId,
          isUse: 0,
          shopId: item.shopId,
        }).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      } else {
        functionEdit({
          iconId: item.iconId,
          isUse: 1,
          shopId: item.shopId,
        }).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      }
    },

    formatDate(date) {
    if (date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始
      const day = ('0' + date.getDate()).slice(-2);
      const formattedDate = `${year}-${month}-${day}`;
      
      // 可以在这里做其他操作，例如赋值给 item 或提交到后端
      console.log('格式化后的日期:', formattedDate);
      
      // 如果需要更新 item.date 为字符串格式
      this.$set(this.currentItem, 'date', formattedDate); // 响应式更新
    }
  },
    handleSubmit(item) {
      console.log("提交电子会员有效期的data:", item);
      if (!item) {
        console.log("Form submitted without item");
        return;
      }
      if (item.iconName === '注册电子会员') {
        const formatDate  = this.formatDate(item.date);
        console.log("提交电子会员有效期的data数据:", formatDate);
        functionEditDate({
          iconId: item.iconId,
          electronic_card_date: formattedDate,
          shopId: item.shopId,
        }).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      }
    },
    showtable(show) {
      this.show = show;
    },
    async getStoreFunction() {
      let shopId = this.$route.query.shopId;
      await storeFunction(shopId).then((res) => {
        this.Details = res.data;
        console.log(res.data);
      });
    },
    goBack() {
      this.$router.push({ name: 'merchants' });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/right/iconControl/iconControl.vue